(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.blogSideBar = {
    attach: function (context, settings) {
      $('#mobile-archives, #mobile-categories').change(function () {
        window.location = $(this).val();
      });
    }
  };
})(jQuery, Drupal);
